import React, { useEffect, useState } from 'react';
import './BottomMenu.css';
import { useTranslation } from 'react-i18next';

// SVG иконки
const HomeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9L12 3L21 9V20H15V14H9V20H3V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M3 9L12 3L21 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M9 22V14H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

const ProfileIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 21V19C20 16.8 18.2 15 16 15H8C5.8 15 4 16.8 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

const CartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 6L7 19H18L19 6H6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M9 6V5C9 3.9 9.9 3 11 3H13C14.1 3 15 3.9 15 5V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <circle cx="9" cy="20" r="1.5" stroke="currentColor" strokeWidth="2" fill="none"/>
    <circle cx="16" cy="20" r="1.5" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>
);

const AdminIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9V12C5 16.17 8.03 19.63 12 19.97" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16.5 9.4L12 13.9L10 11.9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <circle cx="17.5" cy="16.5" r="4.5" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M17.5 14V17L19 18.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

const InfoIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="8" r="1" fill="currentColor"/>
  </svg>
);

// const API_URL = 'http://localhost:3001/api';
const API_URL = 'https://med-bot.dev-alb.ru/api';

const BottomMenu = ({ currentPage, onNavigate, cartItemsCount, adminIps, onOpenEducational }) => {
  const { t } = useTranslation();
  const [showAdminButton, setShowAdminButton] = useState(false);
  const [allowedIps, setAllowedIps] = useState([]);

  useEffect(() => {
    const fetchAdminIps = async () => {
      try {
        const response = await fetch(`${API_URL}/admin-ips`);
        const data = await response.json();
        setAllowedIps(data);
      } catch (error) {
        console.error('Ошибка загрузки IP адресов:', error);
      }
    };
    
    fetchAdminIps();
  }, []);

  useEffect(() => {
    const checkIpAccess = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        const clientIp = data.ip;
        
        const hasAccess = allowedIps.some(ip => ip.ip_address === clientIp);
        setShowAdminButton(hasAccess);
      } catch (error) {
        console.error('Ошибка получения IP:', error);
        setShowAdminButton(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
      }
    };
    
    if (allowedIps.length > 0) {
      checkIpAccess();
    }
  }, [allowedIps]);

  // Определяем, какую вкладку показывать активной
  // Для страниц staff, doctor, admin - активной делаем "Главную" (или "Профиль", по желанию)
  const getActivePage = () => {
    // Если мы на страницах, которых нет в меню, показываем активной "Главную"
    if (currentPage === 'staff' || currentPage === 'doctor') {
      return 'profile';
    }
    return currentPage;
  };

  const activePage = getActivePage();

  const menuItems = [
    {
      id: 'main',
      icon: HomeIcon,
      label: t('Главная'),
      action: () => onNavigate('main')
    },
    {
      id: 'info',
      icon: InfoIcon,
      label: t('Инфоцентр'),
      action: () => onOpenEducational && onOpenEducational()
    },
    {
      id: 'profile',
      icon: ProfileIcon,
      label: t('Профиль'),
      action: () => onNavigate('profile')
    },
    {
      id: 'cart',
      icon: CartIcon,
      label: t('Корзина'),
      action: () => onNavigate('cart'),
      badge: cartItemsCount > 0 ? cartItemsCount : null
    }
  ];

  if (showAdminButton) {
    menuItems.push({
      id: 'admin',
      icon: AdminIcon,
      label: t('Админ'),
      action: () => onNavigate('admin')
    });
  }

  return (
    <div className="bottom-menu">
      {menuItems.map((item) => {
        const IconComponent = item.icon;
        return (
          <button
            key={item.id}
            className={`menu-item ${activePage === item.id ? 'active' : ''}`}
            onClick={item.action}
          >
            <span className="menu-icon">
              <IconComponent />
            </span>
            <span className="menu-label">{item.label}</span>
            {item.badge && <span className="menu-badge">{item.badge}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default BottomMenu;